// import React, { useEffect, useState } from "react";
// import "./MeatalPriceUpdate.scss";
// import CustomTextField from "../../TextFiled/Index";
// import { Button, CircularProgress, MenuItem } from "@mui/material";
// import Header from "../Home/Header/Header";
// import { MetalMasterData } from "../../../Utils/API/MetalMasterData/MetalMasterData";
// import Snackbar from "./snackbar/Snackbar";

// const MeatalPriceUpdate = () => {
//   const [responseData, setResponseData] = useState([]);
//   const [dropdownOptions, setDropdownOptions] = useState([]);
//   const [selectedMetal, setSelectedMetal] = useState("");
//   const [purchasePrice, setPurchasePrice] = useState("");
//   const [salePrice, setSalePrice] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     setIsLoading(true);
//     MetalMasterData("Master_MetalType")
//       .then((response) => {
//         if (response?.Data?.DT) {
//           const baseMetals = response.Data.DT.filter(
//             (item) => item.IsBaseMetal === 1
//           );
//           setResponseData(response.Data.DT);
//           const uniqueMetalNames = Array.from(
//             new Set(baseMetals.map((item) => item.MetalTypeName))
//           );
//           setDropdownOptions(uniqueMetalNames);
//           const defaultGoldData = baseMetals.find(
//             (item) => item.MetalTypeName === "GOLD"
//           );
//           if (defaultGoldData) {
//             setSelectedMetal(defaultGoldData.MetalTypeName);
//             setPurchasePrice(defaultGoldData.PurchasePrice);
//             setSalePrice(defaultGoldData.SalePrice);
//           }
//           setIsLoading(false);
//         }
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   const handleDropdownChange = (event) => {
//     const selectedValue = event.target.value;
//     setSelectedMetal(selectedValue);
//     const selectedMetalData = responseData.find(
//       (item) => item.MetalTypeName === selectedValue && item.IsBaseMetal === 1
//     );
//     if (selectedMetalData) {
//       setPurchasePrice(selectedMetalData.PurchasePrice);
//       setSalePrice(selectedMetalData.SalePrice);
//     }
//   };

//   const handleSave = () => {
//     setIsLoading(true);
//     MetalMasterData("MetalRateSave", selectedMetal, purchasePrice, salePrice)
//       .then((response) => {
//         setIsLoading(false);
//         setSnackbarOpen(true);
//         setTimeout(() => {
//           setSnackbarOpen(false);
//         }, 3000);
//       })
//       .catch((err) => console.log(err));
//   };

//   return (
//     <div className="metalPriceMain_div">
//       {isLoading && (
//         <div className="loader-overlay">
//           <CircularProgress className="loadingBarManage" />
//         </div>
//       )}
//       <Header otherPage={true} title="Metal Price Update" />
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "25px",
//           marginInline: "5px",
//           paddingTop: "60px",
//         }}
//       >
//         {/* Dropdown for Metal Types */}
//         <div className="metalUpdate_div">
//           <p className="metalprice_textbox_label">Metal Type</p>
//           <CustomTextField
//             select
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#685dd8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             className="allCustomize_textinput"
//             value={selectedMetal}
//             onChange={handleDropdownChange}
//           >
//             <MenuItem value="">
//               <em>None</em>
//             </MenuItem>
//             {dropdownOptions.map((option, index) => (
//               <MenuItem key={index} value={option}>
//                 {option}
//               </MenuItem>
//             ))}
//           </CustomTextField>
//         </div>

//         <div className="metalUpdate_div">
//           <div style={{ minWidth: "150px" }}>
//             <p className="metalprice_textbox_label">Purchase Price:</p>
//             <p className="metalprice_textbox_Sublabel">{selectedMetal}</p>
//           </div>
//           <div>
//             <CustomTextField
//               customBorderColor="rgba(47, 43, 61, 0.2)"
//               value={purchasePrice}
//               onChange={(e) => setPurchasePrice(e.target.value)}
//               className="allCustomize_textinput"
//             />
//           </div>
//         </div>

//         <div className="metalUpdate_div">
//           <div style={{ minWidth: "150px" }}>
//             <p className="metalprice_textbox_label">Sale Price:</p>
//             <p className="metalprice_textbox_Sublabel">{selectedMetal}</p>
//           </div>
//           <div>
//             <CustomTextField
//               customBorderColor="rgba(47, 43, 61, 0.2)"
//               value={salePrice}
//               onChange={(e) => setSalePrice(e.target.value)}
//               className="allCustomize_textinput"
//             />
//           </div>
//         </div>

//         <div style={{ display: "flex", justifyContent: "center" }}>
//           <Button
//             variant="contained"
//             className="metal_save_btn"
//             onClick={handleSave}
//           >
//             Save
//           </Button>
//         </div>
//       </div>
//       <Snackbar message="Successfully saved!" open={snackbarOpen} />
//     </div>
//   );
// };

// export default MeatalPriceUpdate;



import React, { useEffect, useState } from "react";
import "./MeatalPriceUpdate.scss";
import CustomTextField from "../../TextFiled/Index";
import { Button, CircularProgress } from "@mui/material";
import Header from "../Home/Header/Header";
import { MetalMasterData } from "../../../Utils/API/MetalMasterData/MetalMasterData";
import Snackbar from "./snackbar/Snackbar";

const MeatalPriceUpdate = () => {
  const [responseData, setResponseData] = useState([]);
  const [selectedMetal, setSelectedMetal] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [purchasePriceError, setPurchasePriceError] = useState("");
  const [salePriceError, setSalePriceError] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    MetalMasterData("Master_MetalType")
      .then((response) => {
        setIsLoading(false);
        if (response?.Data?.DT) {
          const baseMetals = response.Data.DT.filter(
            (item) => item.IsBaseMetal === 1
          );
          setResponseData(baseMetals);
          const defaultMetal =
            baseMetals.find((item) => item.MetalTypeName === "GOLD") ||
            baseMetals[0];

          if (defaultMetal) {
            setSelectedMetal(defaultMetal.MetalTypeName);
            setPurchasePrice(defaultMetal.PurchasePrice);
            setSalePrice(defaultMetal.SalePrice);
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const handleMetalClick = (metalName) => {
    setSalePriceError('');
    setPurchasePriceError('');
    
    const metalData = responseData.find(
      (item) => item.MetalTypeName === metalName
    );
    if (metalData) {
      setSelectedMetal(metalData.MetalTypeName);
      setPurchasePrice(metalData.PurchasePrice);
      setSalePrice(metalData.SalePrice);
    }
  };

  const handleSave = () => {
    let isValid = true;

    if (!purchasePrice) {
      setPurchasePriceError("Purchase Price is required");
      isValid = false;
    }
    if (!salePrice) {
      setSalePriceError("Sale Price is required");
      isValid = false;
    }

    if (isValid && selectedMetal) {
      setIsLoading(true);
      MetalMasterData("MetalRateSave", selectedMetal, purchasePrice, salePrice)
        .then(() => {
          setIsLoading(false);
          setSnackbarOpen(true);
          setTimeout(() => {
            setSnackbarOpen(false);
          }, 3000);
        })
        .catch((err) => console.log(err));
    }
  };

  const handlePurchasePriceChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return; // Allow only numbers
    setPurchasePrice(value);
    if (value) setPurchasePriceError("");
  };

  const handleSalePriceChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return; // Allow only numbers
    setSalePrice(value);
    if (value) setSalePriceError("");
  };

  return (
    <div className="metalPriceMain_div">
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <Header otherPage={true} title="Metal Price Update" />
      {responseData?.length !== 0 && (
        <div style={{ paddingTop: "50px" }}>
          <div className="metal_box_view_main">
            <p className="metalType_textbox_label">Metal Type :</p>
            <div className="metal_box_view">
              {responseData.map((item, index) => (
                <Button
                  key={index}
                  variant={
                    selectedMetal === item.MetalTypeName
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => handleMetalClick(item.MetalTypeName)}
                  style={{
                    backgroundColor:
                      selectedMetal === item.MetalTypeName && "#7367f0",
                  }}
                >
                  {item.MetalTypeName}
                </Button>
              ))}
            </div>
          </div>

          <div className="metal_box_view_main">
            <div className="metalUpdate_div">
              <div style={{ minWidth: "150px" }}>
                <p className="metalprice_textbox_label">Purchase Price:</p>
              </div>
              <CustomTextField
                value={purchasePrice}
                onChange={handlePurchasePriceChange}
                className="allCustomize_textinput"
                error={!!purchasePriceError}
                helperText={purchasePriceError}
              />
            </div>

            <div
              className="metalUpdate_div"
              style={{ margin: "10px 0px", paddingBottom: "20px" }}
            >
              <div style={{ minWidth: "150px" }}>
                <p className="metalprice_textbox_label">Sale Price:</p>
              </div>
              <CustomTextField
                value={salePrice}
                onChange={handleSalePriceChange}
                className="allCustomize_textinput"
                error={!!salePriceError}
                helperText={salePriceError}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <Button
              variant="contained"
              className="metal_save_btn"
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      )}
      <Snackbar message="Successfully saved!" open={snackbarOpen} />
    </div>
  );
};

export default MeatalPriceUpdate;
